import { atom } from 'jotai';;
import { appAtom } from './App.atom';

const searchTermAtom = atom<string>((get) => get(appAtom)?.searchTerm);

export { searchTermAtom };
